export default {
      id: "logo_4-usage",
      viewBox: "0 0 132 132",
      url: __webpack_public_path__ + "img/icons.14f187a1.svg#logo_4",
      toString: function () {
        return this.url;
      }
    }